import { docReady } from '../helpers/doc-ready';
const nativeSearchDrawerFocus = () => {
    const searchDrawerToggles = document.querySelectorAll('[aria-controls="search-drawer"]');
    searchDrawerToggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
            /*
            This is not an ideal solution!
            iOS appears to be sensitive to applying :focus to elements that are not visible.
            This includes display: none, visibility: hidden etc
            */
            const fakeInput = document.createElement('input');
            fakeInput.setAttribute('type', 'search');
            fakeInput.style.position = 'absolute';
            fakeInput.style.opacity = 0;
            fakeInput.style.height = 0;
            fakeInput.style.fontSize = '16px'; // disable auto zoom
            document.body.prepend(fakeInput);
            fakeInput.focus();
            setTimeout(() => {
                const searchInput = document.querySelector('search-drawer input[type="search"]');
                searchInput.focus();
                fakeInput.remove();
            }, 100);
        });
    });
};
docReady(() => {
    nativeSearchDrawerFocus();
});
